import { Fragment } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import Nav from './components/Nav/Nav'
import TopButton from './components/TopButton/TopButton'

import Home from './Pages/Home'
import Install from './Pages/Install'
import Misc from './Pages/Misc/Misc'
import Grid from './Pages/Grid/Grid'
import Elements from './Pages/Elements/Elements'
import Components from './Pages/Components/Components';
import NotFound from './Pages/NotFound/NotFound'


function App() {

  return <Fragment>
    <Nav />
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/install" component={Install} />
      <Route path="/misc" component={Misc} />
      <Route path="/grid" component={Grid} />
      <Route path="/elements" component={Elements} />
      <Route path="/components" component={Components} />
      <Route component={NotFound} />
    </Switch>
    <TopButton />
  </Fragment>

}

export default withRouter(App);
